import { render, staticRenderFns } from "./MeetingDescription.vue?vue&type=template&id=459196a9"
import script from "./MeetingDescription.vue?vue&type=script&lang=js"
export * from "./MeetingDescription.vue?vue&type=script&lang=js"
import style0 from "./MeetingDescription.vue?vue&type=style&index=0&id=459196a9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports